<div [class]="'message ' + ' ' + position">
    <ng-content select="[img]"></ng-content>

    <span class="message-content">
        <span class="message-content-title"><ng-content select="[title]"></ng-content></span>
        <p class="message-content-desc"><ng-content select="[desc]"></ng-content></p>
        <ng-content select="[action]"></ng-content>
    </span>
</div>
